import { Auth0Provider } from '@auth0/auth0-react';
import { system } from 'api/client';

export const AzureAdAuth0Provider = ({ children }) => {
    const domain = process.env[`REACT_APP_AUTH0_DOMAIN_${system.toUpperCase()}`];
    // Use the Azure AD-specific app for employees; fall back to the default app for non-prod
    const clientId =
        process.env[`REACT_APP_AUTH0_AZURE_CLIENT_ID_${system.toUpperCase()}`] ||
        process.env[`REACT_APP_AUTH0_CLIENT_ID_${system.toUpperCase()}`];
    const audience = process.env[`REACT_APP_AUTH0_AUDIENCE_${system.toUpperCase()}`];

    return (
        <Auth0Provider
            domain={domain}
            clientId={clientId}
            authorizationParams={{
                redirect_uri: window.location.origin,
                audience,
                scope: 'openid profile email offline_access',
            }}
            useRefreshTokens={true}
            cacheLocation="localstorage"
        >
            {children}
        </Auth0Provider>
    );
};
